import { DialogContent, Grid } from '@mui/material'
import AddDialog from 'src/components/AddDialog/addDialog'
import { FC, useState } from 'react'
import 'react-client-captcha/dist/index.css'
import './styles/forgotPassword.Module.css'
import GetConfirmationCode, { IResult } from './components/getConfirmationCode'
import SetNewPassword from './components/setNewPassword'
import { IModalProps } from 'src/models/interfaces/IModalProps'

interface IProps extends IModalProps {}

const ForgotPassword: FC<IProps> = ({ open, onClose }) => {
  const [step, setStep] = useState<number>(1)
  const [confirmCodeResult, setConfirmCodeResult] = useState<IResult>()

  const renderSteps = () => {
    switch (step) {
      case 1:
        return (
          <GetConfirmationCode onClose={onClose} setStep={() => setStep(2)} setResult={(result: IResult) => setConfirmCodeResult(result)} />
        )
      case 2:
        return <SetNewPassword onClose={onClose} userInfo={confirmCodeResult} setStep={() => setStep(1)} />
    }
  }

  return (
    <AddDialog title="بازیابی رمز عبور " open={open} onClose={onClose} maxWidth={'sm'}>
      <form>
        <DialogContent
          style={{ minHeight: step === 1 ? 300 : 400, overflow: 'hidden', padding: '2.5rem', paddingTop: '1rem', position: 'relative' }}
        >
          <Grid item container spacing={1} display={'flex'} justifyContent={'center'}>
            {renderSteps()}
          </Grid>
        </DialogContent>
      </form>
    </AddDialog>
  )
}

export default ForgotPassword
